import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { NameValueDto } from '@ig-core/interfaces/name-value-dto';
import { ReferenceCodeService } from '@app/admin/reference-code/reference-code.service';
import { ApplicationService } from '@app/applications/application.service';
import { LoanApplication, ApplicationAccessSpecifier } from '@app/applications/applications.model';
import { ReferenceCode } from '@app/admin/reference-code/reference-code.model';
import { ValidationService } from '../../../application-validators/validation.service'
import { MatSnackBar } from '@angular/material';
import { ConfirmationDialogService } from '@app/utils/confirmation-dialog/confirmation-dialog.service';
import { FileUploadService } from '@app/utils/file-upload/file-upload.service';
import { FolderFilesComposite } from '@app/applications/application-details/loanInformation/loan-folder-files/loan-folder-files.model';
import * as fileSaver from 'file-saver';
import { ImagePreviewDialogService } from '@app/utils/image-preview-dialog/image-preview-dialog.service';
import { IgFileService } from '@ig-core/form/igFile.service';
import { Applicant, Collateral, ColletralDetails } from '../collateralDetails/collateral-details.model';
import { Note } from '@app/note/note.model';
@Component({
  selector: 'eng-modt-details',
  templateUrl: 'modt.template.html',
  styleUrls: ['../../application-details.styles.scss', './modt.scss']
})
export class ModtComponent implements OnInit {

  @Input()
  application: LoanApplication;
  @Input()
  menuCode: string;

  colletralDetails: ColletralDetails[];
  applicants: Applicant[];
  selectedCollateral: ColletralDetails;
  modtForm: FormGroup;
  collateralTypes: ReferenceCode[] = [];
  modtComplitionStatus: NameValueDto[];
  collateralApplicantsList: NameValueDto[] = [];

  showForm: boolean;
  isFormDisabled: boolean;
  allowAccess: boolean;
  menuItemAllowAccess: boolean;

  allFilesInFolder: FolderFilesComposite;
  collateralModt: any;

  applicationAccessSpecifiers: ApplicationAccessSpecifier[];
  menuItemAccessSpecifier: ApplicationAccessSpecifier;
  constructor(private formBuilder: FormBuilder,
    private referenceCodeService: ReferenceCodeService,
    private applicationService: ApplicationService,
    private _snackbar: MatSnackBar,
    private fileUploadService: FileUploadService,
    private imagePreviewDialogService: ImagePreviewDialogService,
    private confirmationDialogService: ConfirmationDialogService,
    private validationService: ValidationService,
    private fileService: IgFileService) {
    this.modtForm = this.formBuilder.group({
      modtStatus: '',
      remarks: ''
    });
    this.allowAccess = this.applicationService.allowAccess;
  }

  ngOnInit() {
    this.isFormDisabled = true;
    this.fetchApplicants();
    this.refreshApplicationData();
    this.getMenuItemAccess();
  }

  getRefCodes() {
    //it is possible that we may restrict that -prop must be present 
    let collateralSet = this.application.collateralSet
    this.referenceCodeService.getRefCodesForClassifier(collateralSet).subscribe((response: any) => {
      this.collateralTypes = response;
      this.applyValidatorsToCollateralModt();
    });

    this.referenceCodeService.getShortRefCodes('modt_status').subscribe((response: any) => {
      this.modtComplitionStatus = response.modt_status;
    });

  }

  fetchCollateralDetails() {
    this.showForm = false;
    this.applicationService.getCollateralDetails(this.application.uid).subscribe((response: any) => {
      if (response) {
        this.colletralDetails = response;
        this.colletralDetails.forEach((element, index) => {
          let CheckType = this.collateralTypes.filter(object => { return object.code == element.collateral.collateralType })
          if (CheckType.length == 0 && this.collateralTypes.length != 0) {
            this.colletralDetails[index]["showInRed"] = true
          }
        });
        this.showForm = (this.colletralDetails && this.colletralDetails.length > 0);
        this.getModtDetails(this.colletralDetails[0]);
      }
    })
  }

  getModtDetails(collateraldetails) {
    this.selectedCollateral = collateraldetails;
    this.applicationService.getCollateralModt(this.application.uid, collateraldetails.collateral.uid).subscribe(response => {
      this.collateralModt = response;
      this.buildModtCollateralForm(this.collateralModt)
    })
  }

  fetchApplicants() {
    this.showForm = false;
    this.applicationService.getApplicants(this.application.uid).subscribe((response: any) => {
      if (response) {
        this.applicants = response;
        this.collateralApplicants();
      }
    })
  }

  collateralApplicants() {
    this.applicants.forEach((applicantsObject) => {
      let applicant = { code: applicantsObject.uid, name: applicantsObject.name + '  ' + '(' + applicantsObject.play + ')' }
      this.collateralApplicantsList.push(<NameValueDto>applicant);
    })
  }

  changeSelectedCollateral(collateraldetails?: ColletralDetails) {
    this.showForm = true;
    this.getModtDetails(collateraldetails);
  }

  buildModtCollateralForm(collateralModt?: any) {
    if (this.showForm) {
      this.modtForm.patchValue({
        modtStatus: collateralModt.collateralModtDTO.status || '',
        remarks: ''
      })

      this.getSelectedFolderFiles(this.collateralModt.collateralModtDTO.folderUid);
    }
    this.modtForm.disable();
  }

  saveModt() {
    this.validationService.markFormGroupTouched(this.modtForm)
    if (!this.isFormDisabled && this.modtForm.valid) {
      if (!this.collateralModt.collateralModtDTO.uid) {
        this.collateralModt.collateralModtDTO.contextUid = this.application.uid;
      }
      let motdDetailsFormFields = this.modtForm.controls;
      this.collateralModt.collateralModtDTO.status = motdDetailsFormFields.modtStatus.value;
      let note: Note = {
        content: motdDetailsFormFields.remarks.value
      };
      this.collateralModt.notes = [note];
      this.applicationService.saveModtDetails(this.application.uid, this.selectedCollateral.collateral.uid, this.collateralModt).toPromise().then(
        (_success) => {
          this._snackbar.open("Modt updated successfully", "Close", {
            duration: 2000,
          });
          this.isFormDisabled = true
          this.fetchCollateralDetails();
        }, (failure) => {
          let errormesg = []
          errormesg.push(failure)
          this.applicationService.displayErrorMessages(errormesg);
        }
      );
    }
  }

  enableDisableForm() {
    this.modtForm.enable()
    this.isFormDisabled = false;
  }

  cancelForm() {
    if (this.colletralDetails && this.colletralDetails.length > 0) {
      this.getModtDetails(this.colletralDetails[0]);
    } else {
      this.showForm = false;
    }
    this.isFormDisabled = true;
    this.modtForm.disable();
  }

  //this function will apply validators to form group
  applyValidatorsToCollateralModt() {
    this.validationService.applyValidationRules(this.modtForm, "ModtDetails").then((controlValidators) => {
      this.fetchCollateralDetails();
      //this.basedOnProductTypeDisableFields();
    }).catch(() => {
    })
  }

  //this function will get either this menu item  is editable or readonly 
  getMenuItemAccess() {
    this.applicationService.getApplicationAccessModifiers(this.application.uid)
      .subscribe((response) => {
        this.applicationAccessSpecifiers = response.body;
        this.menuItemAccessSpecifier = this.applicationAccessSpecifiers
          .find(accessSpecifier => accessSpecifier.category === this.menuCode);
        if (this.menuItemAccessSpecifier) {
          this.menuItemAllowAccess = this.menuItemAccessSpecifier.allowAccess;
        }
      });
  }

  //this function will call to get basic application data 
  // to refresh "this.application" values after particular action eg: after decision save like proceed in sidenav
  refreshApplicationData() {
    this.applicationService.getBasicApplicationInfo(this.application.uid, 'ApplicationOnly').subscribe((response) => {
      this.application = response.body.applicationDTO;
      this.getRefCodes();
    });
  }

  //this function open up the image upload dailog box
  //if file upload should allow single and multiple file upload, we need to pass "uploadType":"multiple"
  openImageFileUploadDialog() {
    if (this.collateralModt.collateralModtDTO.folderUid != null) {
      this.fileUploadService.open({ "uploadType": "multiple", "folderUid": this.collateralModt.collateralModtDTO.folderUid, "applicationUid": this.application.uid, "files": this.allFilesInFolder.fileInfo })
      this.fileUploadService.confirmed().subscribe(data => {
        this.getSelectedFolderFiles(data.folderUid)
      })

    } else {
      this._snackbar.open("Please add a folder to upload files", "Close", {
        duration: 5000,
      });
    }
  }

  getSelectedFolderFiles(folderUid) {
    if (folderUid) {
      this.applicationService.getAllFilesInApplicationFolder(this.application.uid, folderUid).subscribe((response: any) => {
        if (response) {
          this.allFilesInFolder = response.body;
          this.allFilesInFolder.fileInfo.forEach(element => {
            if (element.fileSize) {
              element["convertedFileSize"] = this.applicationService.bytesToSize(element.fileSize)
            }
          });
        }
      });
    }
  }

  //this function will call onclick of download icon in file's section
  downloadFile(file) {
    this.applicationService.downloadFileFromApplicationFolder(this.application.uid, file.folderUid, file.fileId).subscribe(image => {
      const blob = new Blob([image.data], { type: file.type });
      fileSaver.saveAs(blob, file.fileName);
      this._snackbar.open("File has been downloaded successfully", "Close", {
        duration: 5000,
      });
    })
  }

  //this function will trigger onclicking of image,will open up a mat-dailog
  openContentElement() {
    this.imagePreviewDialogService.open({ "images": this.allFilesInFolder })
  }


  openfileDeleteConfirmation(selectedFile) {
    this.confirmationDialogService.open({ "btnCancelText": "Cancel", "btnConfirmText": "Delete", "message": "Are you sure you want to delete this File?" })
    this.confirmationDialogService.confirmed().subscribe(data => {
      if (data) {
        this.deleteFile(selectedFile)
      }
    })

  }

  //this function will be called on click of delete icon on file list
  deleteFile(selectedFile) {
    this.applicationService.fileDelete(this.application.uid, selectedFile.uid).subscribe((response) => {
      if (response.body.status == "success") {
        this._snackbar.open("File deleted successfully", "Close", {
          duration: 2000,
        });
        this.getSelectedFolderFiles(this.collateralModt.collateralModtDTO.folderUid);
      } else {
        let errormesg = []
        errormesg.push("File deleted failed")
        errormesg.push(response.body.message)
        this.applicationService.displayErrorMessages(errormesg);
      }
    }, (failure) => {
      let errormesg = []
      errormesg.push("File deleted failed")
      errormesg.push(failure)
      this.applicationService.displayErrorMessages(errormesg);
    });
  }

  viewPdf(file) {
    this.fileService.fileStreamById(file.fileId, "false").subscribe(res => {
      window.open(res.data, '_blank');
    })
  }

}